import React from "react";
import classNames from "classnames/bind";

import styles from "./Container.module.css";

const cx = classNames.bind(styles);

export const Container: React.FC<{}> = (props) => (
  <div className={cx("wrapper")} id={"wrapper"}>
    <div className={cx("content")}>{props.children}</div>
  </div>
);
